/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Pastdue1Inputs */

const zh_status_pastdue1 = /** @type {(inputs: Status_Pastdue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已逾期`)
};

const en_status_pastdue1 = /** @type {(inputs: Status_Pastdue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Due`)
};

const es_status_pastdue1 = /** @type {(inputs: Status_Pastdue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vencido`)
};

/**
* | output |
* | --- |
* | "Past Due" |
*
* @param {Status_Pastdue1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const status_pastdue1 = /** @type {((inputs?: Status_Pastdue1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Pastdue1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_status_pastdue1(inputs)
	if (locale === "en") return en_status_pastdue1(inputs)
	return es_status_pastdue1(inputs)
});
export { status_pastdue1 as "status_pastDue" }